import React, { act } from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { LoadState } from "@/helpers/useDelayedState"
import { buildProductState } from "@/test/helpers/mockProductState"

jest.mock("@/onboarding/features/product/helpers", () => {
  const ReactActual = jest.requireActual("react")

  return {
    SubmittingContext: ReactActual.createContext([]),
    useProductSubmitting: () => [false, jest.fn()],
  }
})

jest.mock("@/components/chat", () => ({
  ChatButton: () => null,
}))

jest.mock("../Importer", () => () => null)

// eslint-disable-next-line import/first
import SectionHolder from "../SectionHolder"
;(globalThis as any).IS_REACT_ACT_ENVIRONMENT = true

const buildStore = (state) =>
  ({
    getState: () => state,
    subscribe: () => () => {},
    dispatch: jest.fn(),
  }) as any

const renderSectionHolder = ({ canEditProduct }: { canEditProduct: boolean }) => {
  const container = document.createElement("div")
  document.body.appendChild(container)

  const state = buildProductState({
    canEdit: canEditProduct,
    features: {
      general: {
        product: {
          comment: false,
          editable: canEditProduct,
          sectionSettings: {
            sections: [{ key: "extra_fees", writeable: false }],
          },
        },
      },
    },
  })

  state.product._view.state = LoadState.Ready

  act(() => {
    createRoot(container).render(
      <Provider store={buildStore(state)}>
        <SectionHolder title="Extra Fees" name="extra_fees" showLockedIcon>
          <div>Extra fee content</div>
        </SectionHolder>
      </Provider>
    )
  })

  return container
}

describe("SectionHolder", () => {
  afterEach(() => {
    document.body.innerHTML = ""
  })

  it("does not show a lock icon in read-only product views", () => {
    const container = renderSectionHolder({ canEditProduct: false })

    expect(container.querySelector("[title='This component is fixed']")).toBeNull()
  })

  it("shows a requested lock icon when the product view is editable", () => {
    const container = renderSectionHolder({ canEditProduct: true })

    expect(container.querySelector("[title='This component is fixed']")).not.toBeNull()
  })
})
